import { EMessengerEventBusEvents } from '@xometry/ui';
import { amplitudeLogger } from 'amplitude';
import { ErpMessengerMicroFrontend } from 'components/MicroFrontend/ErpMessengerMicroFrontend';
import { MICRO_FRONTEND_NAME } from 'components/MicroFrontend/MicroFrontend.types';
import { HeaderControls } from 'components/SideOverlayContainer/HeaderControls';
import { ENV_MESSENGER_URL } from 'constants/env';
import { observer } from 'mobx-react-lite';
import React, { useCallback, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useStore } from 'stores/RootStore';
import { ESide } from 'stores/SideOverlay/SideOverlayStore';
import { DeviceTypes, useDeviceType } from 'utils/hooks/useDeviceType';
import { useEmbedded } from 'utils/hooks/useEmbedded';
import { useMessengerEventBus } from 'utils/hooks/useMessengerEventBus';
import { buildDealMessengerChatSource } from 'utils/messenger/buildDealMessengerChatSource';
import { computeErpMainMessengerHostState } from 'utils/messenger/computeErpMainMessengerHostState';
import { resolveDealIdForMessengerHostOverlays } from 'utils/messenger/resolveDealIdForMessengerHostOverlays';

import s from './CompactMessengerPanel.module.less';

const CompactMessengerPanelComponent = () => {
  const store = useStore();
  const { isEmbedded } = useEmbedded();
  const deviceType = useDeviceType();
  const { setEventBusRef, sendEvent } = useMessengerEventBus();
  const sendEventRef = useRef(sendEvent);

  sendEventRef.current = sendEvent;

  const handleCloseCompactMessenger = useCallback(() => {
    sendEventRef.current?.(EMessengerEventBusEvents.CLOSE_MESSENGER, {});
    store.previewsStore.closePreview();
    store.sideOverlayStore.closeSideOverlay();
  }, [store]);
  const { pathname, search } = useLocation();

  const isMobile = deviceType === DeviceTypes.MOBILE && !isEmbedded;

  const dealIdForThread = resolveDealIdForMessengerHostOverlays(pathname, store);

  const liveDealThreadChatSource =
    dealIdForThread != null && dealIdForThread !== ''
      ? buildDealMessengerChatSource({ pathname, search, dealId: dealIdForThread, store })
      : null;

  const { showCompactColumnMessenger, appParams, microFrontendKey } = computeErpMainMessengerHostState(store, {
    isMobile,
    isEmbedded,
    setEventBusRef,
    amplitudeLogger,
    liveDealThreadChatSource,
  });

  if (!showCompactColumnMessenger || !appParams) return null;

  return (
    <>
      <div className={`${s.layoutReserve} erpCompactMessengerShellMarker`} aria-hidden />

      <aside className={s.aside}>
        <div className={s.inner}>
          <div className={s.mfHost}>
            <HeaderControls
              onClose={handleCloseCompactMessenger}
              side={ESide.Right}
              messengerLayoutToggle={{
                currentMode: 'compact',
                onToggle: () => {
                  store.erpMessengerLayoutStore.requestClassicMessengerLayout();
                },
              }}
            />
            <ErpMessengerMicroFrontend
              key={microFrontendKey}
              name={MICRO_FRONTEND_NAME.Messenger}
              containerId="MessengerCompactContainer"
              host={ENV_MESSENGER_URL}
              appParams={appParams}
            />
          </div>
        </div>
      </aside>
    </>
  );
};

export const CompactMessengerPanel = observer(CompactMessengerPanelComponent);
